/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sweet_Trite_Coyote_TalkInputs */

const fr_sweet_trite_coyote_talk = /** @type {(inputs: Sweet_Trite_Coyote_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'historique`)
};

/**

* @param {Sweet_Trite_Coyote_TalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sweet_trite_coyote_talk = /** @type {((inputs?: Sweet_Trite_Coyote_TalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sweet_Trite_Coyote_TalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sweet_trite_coyote_talk(inputs)
});